import { render, staticRenderFns } from "./LeadPurchaseItem.vue?vue&type=template&id=cfe7c1e4&scoped=true&"
import script from "./LeadPurchaseItem.vue?vue&type=script&lang=js&"
export * from "./LeadPurchaseItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadPurchaseItem.vue?vue&type=style&index=0&id=cfe7c1e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfe7c1e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
